/* Nuvō product photo zoom (Nov 1 2026), loaded by snippets/nuvo-pdp.liquid on product pages only.
   Desktop: hovering the main photo magnifies it and the view follows the cursor; a click still opens the theme's
   full-screen viewer. Phones and tablets: press and hold the photo to magnify it, slide the finger to look around,
   lift to let go. A quick tap still opens the viewer and a swipe still changes photo. */
(() => {
  const SCALE = 2.4;
  const HOLD = 260;   /* ms a finger must rest before the zoom starts */
  const SLOP = 8;     /* px a finger may drift before it counts as a swipe */

  const style = document.createElement('style');
  style.textContent = `
    .template__product ul.slider--desktop .slider__slide .image--wrapper { overflow: hidden; }
    .template__product ul.slider--desktop .slider__slide img { transition: transform .35s cubic-bezier(.16,1,.3,1); will-change: transform; }
    .template__product ul.slider--desktop .slider__slide.nz-on img { transition: transform .12s ease-out; }
    @media (hover: hover) and (pointer: fine) { .template__product ul.slider--desktop .slider__slide, .template__product ul.slider--desktop .slider__slide modal-opener > button { cursor: zoom-in; } }
    .nz-hint { position: absolute; right: 12px; bottom: 12px; z-index: 3; display: flex; align-items: center; gap: 6px; padding: 6px 11px;
      border-radius: 999px; background: rgba(255,255,255,.88); box-shadow: 0 6px 16px rgba(17,17,17,.12); pointer-events: none;
      font: 500 11px/1 var(--font-body-family, Montserrat), sans-serif; color: #111; transition: opacity .3s ease; }
    .nz-hint svg { width: 13px; height: 13px; fill: none; stroke: currentColor; stroke-width: 1.7; stroke-linecap: round; }
    .slider__slide.nz-on .nz-hint { opacity: 0; }`;
  document.head.appendChild(style);

  const slides = () => document.querySelectorAll('.template__product ul.slider--desktop .slider__slide');
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* the zoom needs a sharper file than the one on screen: swap once, the first time a photo is magnified */
  const sharpen = (img) => {
    if (img.dataset.nzHi) return;
    img.dataset.nzHi = '1';
    const src = (img.currentSrc || img.src).replace(/([?&])width=\d+/, '$1width=2400');
    const hi = new Image();
    hi.onload = () => { img.removeAttribute('srcset'); img.src = src; };
    hi.src = src;
  };

  const aim = (slide, img, x, y) => {
    const r = slide.querySelector('.image--wrapper').getBoundingClientRect();
    const px = Math.min(100, Math.max(0, ((x - r.left) / r.width) * 100));
    const py = Math.min(100, Math.max(0, ((y - r.top) / r.height) * 100));
    img.style.transformOrigin = `${px}% ${py}%`;
  };
  const zoomIn = (slide, img, x, y) => {
    sharpen(img);
    aim(slide, img, x, y);
    slide.classList.add('nz-on');
    img.style.transform = `scale(${SCALE})`;
  };
  const zoomOut = (slide, img) => {
    slide.classList.remove('nz-on');
    img.style.transform = '';
  };

  const wire = (slide) => {
    if (slide.dataset.nz) return;
    const wrap = slide.querySelector('.image--wrapper');
    const img = wrap && wrap.querySelector('img');
    if (!img) return;   /* videos and 3D models keep their own controls */
    slide.dataset.nz = '1';

    const hint = document.createElement('span');
    hint.className = 'nz-hint';
    hint.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="8.5" cy="8.5" r="5.5"/><path d="m13 13 4 4M8.5 6v5M6 8.5h5"/></svg>' +
      (fine ? 'Hover to zoom' : 'Hold to zoom');
    wrap.style.position = wrap.style.position || 'relative';
    wrap.appendChild(hint);

    /* the theme lays an invisible "open gallery" button over the photo, so the slide listens, not the image */
    if (fine) {
      slide.addEventListener('mouseenter', (e) => zoomIn(slide, img, e.clientX, e.clientY));
      slide.addEventListener('mousemove', (e) => aim(slide, img, e.clientX, e.clientY));
      slide.addEventListener('mouseleave', () => zoomOut(slide, img));
      return;
    }

    /* touch: hold to zoom, drag to look around, lift to release */
    let timer = null, sx = 0, sy = 0, zooming = false, swallow = false;
    slide.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) return;
      const t = e.touches[0];
      sx = t.clientX; sy = t.clientY;
      clearTimeout(timer);
      timer = setTimeout(() => { zooming = true; swallow = true; zoomIn(slide, img, sx, sy); if (navigator.vibrate) navigator.vibrate(8); }, HOLD);
    }, { passive: true });
    slide.addEventListener('touchmove', (e) => {
      const t = e.touches[0];
      if (zooming) { e.preventDefault(); e.stopPropagation(); aim(slide, img, t.clientX, t.clientY); return; }
      if (Math.abs(t.clientX - sx) > SLOP || Math.abs(t.clientY - sy) > SLOP) clearTimeout(timer);
    }, { passive: false });
    const end = () => { clearTimeout(timer); if (zooming) { zooming = false; zoomOut(slide, img); } };
    slide.addEventListener('touchend', end);
    slide.addEventListener('touchcancel', end);
    /* the lift after a zoom must not open the full-screen viewer, nor the long-press image menu */
    slide.addEventListener('click', (e) => { if (swallow) { swallow = false; e.preventDefault(); e.stopPropagation(); } }, true);
    slide.addEventListener('contextmenu', (e) => { if (zooming || swallow) e.preventDefault(); });
    img.style.webkitTouchCallout = 'none';
    img.style.userSelect = 'none';
  };

  const run = () => slides().forEach(wire);
  run();
  /* the theme rebuilds the gallery when the variant changes */
  const gallery = document.querySelector('.template__product .product__info-block--gallery');
  if (gallery) new MutationObserver(run).observe(gallery, { childList: true, subtree: true });
})();
